import { useState } from 'react';

interface CriticalRiskDriverProps {
	justification: string | null | undefined;
	maxLength?: number;
	className?: string;
}

export const CriticalRiskDriver = ({
	justification,
	maxLength = 150,
	className = '',
}: CriticalRiskDriverProps) => {
	const [isExpanded, setIsExpanded] = useState(false);

	if (!justification) return null;

	const needsTruncation = justification.length > maxLength;
	const displayText =
		isExpanded || !needsTruncation ? justification : `${justification.slice(0, maxLength)}...`;

	return (
		<div
			className={`flex flex-col items-flex-start p-3 gap-2 bg-[#F8FAFC] rounded-lg ${className}`}
			role="alert"
			aria-label="Critical Risk Driver"
		>
			<p className="w-full font-['Inter'] font-normal text-xs leading-5 text-[#314158]">
				{displayText}
				{needsTruncation && (
					<button
						type="button"
						onClick={() => setIsExpanded(!isExpanded)}
						className="ml-1 text-blue-600 hover:text-blue-800 font-medium focus:outline-none"
						aria-expanded={isExpanded}
					>
						{isExpanded ? 'show less' : 'more'}
					</button>
				)}
			</p>
		</div>
	);
};
